import type { TranslationDict } from '../en';

const ro: TranslationDict = {
  'header.buy': 'Cumpără',
  'header.sell': 'Vinde',
  'spend.label': 'Cheltuiești',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Primești',
  'payment.label': 'Metodă de plată',
  'payment.select': 'Selectează',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Nicio metodă de plată pentru această pereche',
  'wallet.label': 'Adresa portofelului de primire',
  'wallet.placeholderBuy': 'Introduceți adresa de primire',
  'wallet.placeholderSell': 'Introduceți adresa de trimitere',
  'wallet.validating': 'Se validează adresa...',
  'wallet.invalid': 'Introduceți o adresă validă de portofel',
  'wallet.invalidServer': 'Adresă de portofel invalidă',
  'cta.buy': 'Cumpără {crypto}',
  'cta.sell': 'Vinde {crypto}',
  'cta.gettingPrice': 'Se caută cel mai bun preț...',
  'cta.processing': 'Se procesează...',
  'footer.poweredBy': 'Funcționează cu ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Detalii curs valutar',
  'rate.close': 'Închide',
  'rate.updatesIn': 'Cursul se actualizează în 00:{seconds}',
  'rate.noQuote': 'Nicio cotație disponibilă',
  'rate.exchangeRate': 'Curs de schimb',
  'rate.processingFee': 'Comision de procesare',
  'rate.networkFee': 'Comision de rețea',
  'rate.provider': 'Furnizor',
  'toast.orderCreated': 'Comandă creată',
  'toast.redirecting': 'Redirecționare spre checkout...',
  'toast.orderFailed': 'Comanda a eșuat',
  'toast.couldNotCreate': 'Nu s-a putut crea comanda',
  'toast.quoteError': 'Eroare cotație',
  'toast.noProviders': 'Niciun furnizor',
  'toast.somethingWrong': 'Ceva a mers greșit',
  'error.amountZero': 'Suma trebuie să fie mai mare decât 0',
  'error.minAmountFiat': 'Suma minimă este {min} {currency}',
  'error.minAmountCrypto': 'Suma minimă este {min} {currency}',
  'error.noProviders': 'Niciun furnizor disponibil pentru această combinație',
  'error.currencyUnavailableBuy': 'Această monedă nu este disponibilă pentru comenzile de cumpărare',
  'error.currencyUnavailableSell': 'Această monedă nu este disponibilă pentru comenzile de vânzare',
  'parity.info': 'Veți fi taxat pentru {receiveAmount} {crypto}, restul până la {spendAmount} {fiat} va fi creditat în contul dvs. {partner}',
  'redirect.secureBadge': 'Plată securizată',
  'redirect.title': 'Continuați plata',
  'redirect.description': 'Veți fi redirecționat către {gateway} pentru a finaliza plata.',
  'redirect.countdown': 'Redirecționare în {seconds}...',
  'redirect.openTab': 'Deschide ACH într-o filă nouă',
  'redirect.cancel': 'Anulează',
  'checkout.noOrder': 'Nicio comandă găsită',
  'checkout.goBack': 'Înapoi',
  'checkout.expired': 'Checkout expirat',
  'checkout.expiredDesc': 'Sesiunea a expirat. Vă rugăm să încercați din nou.',
  'checkout.startOver': 'Începeți din nou',
  'checkout.cancel': 'Anulează',
  'checkout.loading': 'Se încarcă checkout-ul...',
  'checkout.iframeTitle': 'Checkout furnizor',
  'checkout.widgetTitle': 'Checkout plată',
  'checkout.unknownMethod': 'Metodă de checkout necunoscută',
  'processing.default': 'Se procesează comanda dvs....',
  'processing.pending': 'Se așteaptă confirmarea plății...',
  'processing.active': 'Se procesează tranzacția dvs....',
  'processing.generic': 'Se procesează...',
  'processing.checkingStatus': 'Se verifică starea...',
  'processing.orderId': 'ID comandă',
  'processing.provider': 'Furnizor',
  'processing.amount': 'Sumă',
  'processing.receiving': 'Primire',
  'processing.network': 'Rețea',
  'processing.toAddress': 'Adresă destinatar',
  'processing.usuallyMinutes': 'De obicei durează câteva minute.',
  'processing.safeToClose': 'Puteți închide în siguranță această pagină — vă vom trimite un e-mail când se finalizează.',
  'complete.buyTitle': 'Achiziție Finalizată!',
  'complete.sellTitle': 'Vânzare Finalizată!',
  'complete.buyDesc': '{crypto} dvs. a fost trimis în portofelul dvs.',
  'complete.sellDesc': 'Plata dvs. în {fiat} este în curs de procesare.',
  'complete.amountBuy': 'Sumă Primită',
  'complete.amountSell': 'Sumă Vândută',
  'complete.paidBuy': 'Sumă Plătită',
  'complete.paidSell': 'Sumă de Plată',
  'complete.network': 'Rețea',
  'complete.wallet': 'Portofel',
  'complete.transaction': 'Tranzacție',
  'complete.provider': 'Furnizor',
  'complete.orderId': 'ID comandă',
  'complete.completed': 'Finalizat',
  'complete.viewExplorer': 'Vezi în Explorer',
  'complete.done': 'Gata',
  'errorStep.failed': 'Plată Eșuată',
  'errorStep.cancelled': 'Comandă Anulată',
  'errorStep.expired': 'Comandă Expirată',
  'errorStep.refunded': 'Comandă Rambursată',
  'errorStep.unknown': 'Ceva a Mers Greșit',
  'errorStep.failedBuy': 'Plata dvs. nu a putut fi procesată. Vă rugăm să încercați din nou sau să folosiți o altă metodă de plată.',
  'errorStep.failedSell': 'Vânzarea dvs. nu a putut fi procesată. Vă rugăm să încercați din nou.',
  'errorStep.cancelledBuy': 'Comanda dvs. a fost anulată. Nicio plată nu a fost procesată.',
  'errorStep.cancelledSell': 'Vânzarea dvs. a fost anulată. Nicio criptomonedă nu a fost transferată.',
  'errorStep.expiredBuy': 'Comanda dvs. a expirat. Vă rugăm să inițiați o achiziție nouă.',
  'errorStep.expiredSell': 'Comanda dvs. a expirat. Vă rugăm să inițiați o vânzare nouă.',
  'errorStep.refundedBuy': 'Plata dvs. a fost rambursată. Fondurile ar trebui să apară în contul dvs. în 5-10 zile lucrătoare.',
  'errorStep.refundedSell': 'Criptomoneda dvs. a fost returnată. Fondurile ar trebui să apară în curând în portofelul dvs.',
  'errorStep.genericDesc': 'A apărut o eroare neașteptată. Vă rugăm să încercați din nou.',
  'errorStep.orderId': 'ID comandă',
  'errorStep.tryAgain': 'Încearcă din nou',
  'errorStep.startOver': 'Începe din nou',
  'errorStep.return': 'Înapoi',
  'errorStep.needHelp': 'Aveți nevoie de ajutor? Contactați ',
  'errorStep.reference': 'Referință: {orderId}',
  'confirm.buyTitle': 'Confirmați Achiziția',
  'confirm.sellTitle': 'Confirmați Vânzarea',
  'confirm.loading': 'Se încarcă...',
  'confirm.provider': 'Furnizor',
  'confirm.youPay': 'Plătiți',
  'confirm.youSell': 'Vindeți',
  'confirm.youReceive': 'Primiți',
  'confirm.wallet': 'Portofel',
  'confirm.network': 'Rețea',
  'confirm.refundAddress': 'Adresă de rambursare',
  'confirm.parityNote': 'Suma percepută de furnizor poate diferi. Restul până la {amount} {crypto} va fi creditat în contul dvs. {partner}.',
  'confirm.processing': 'Se procesează...',
  'confirm.confirmPay': 'Confirmați și Plătiți',
  'confirm.confirmSell': 'Confirmați și Vindeți',
  'confirm.payout': 'Plată în {currency}',
  'modal.selectFiat': 'Selectați moneda fiat',
  'modal.selectCrypto': 'Selectați criptomoneda',
  'modal.choosePayment': 'Alegeți metoda de plată',
  'modal.selectCountry': 'Selectați țara dvs.',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Popular',
  'modal.recommended': 'Recomandat',
  'modal.noCurrencies': 'Nicio monedă găsită',
  'modal.noPaymentMethods': 'Nicio metodă de plată găsită',
  'modal.noCountries': 'Nicio țară găsită',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Locație',
  'settings.darkMode': 'Mod întunecat',
  'settings.privacy': 'Politica de confidențialitate',
  'settings.terms': 'Termeni de utilizare',
  'settings.language': 'Limbă',
  // ─── Additional ───
  'modal.chooseRamp': 'Alegeți Ramp',
  'modal.bestPrice': 'Cel mai bun preț',
  'modal.noQuotes': 'Nicio cotație disponibilă pentru această cerere',
  'modal.noProvidersFound': 'Niciun furnizor găsit',
  'payment.unavailableFor': 'Nicio metodă de plată disponibilă pentru {currency}',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Crearea comenzii a eșuat',
  'errorStep.returnToMerchant': 'Înapoi la comerciant',
  'confirm.cryptoOnNetwork': '{crypto} pe {network}',
  'payment.name.card': 'Carte',
  'payment.name.bankTransfer': 'Transfer Bancar',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ro;
